import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PublicRoute = ({ children }) => {

  const { user, loading } = useAuth();

  if (loading) return null;

  // ✅ Si connecté → redirige selon rôle
  if (user) {

    if (user.roles.includes("ROLE_ADMIN")) {
      return <Navigate to="/admin" />;
    }

    if (user.roles.includes("ROLE_TRANSPORTER")) {
      return <Navigate to="/transporter/dashboard" />;
    }

    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default PublicRoute;